import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Login.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { menuChanged, selectMenu } from '../../features/infoSlice';

import Logo from '../../components/Logo';
import logo from '../../assets/images/logo/selpub_cloud_account.svg';
import { LOGIN, SERVICE_DESC } from '../../constants';

export default function Login() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const { pathname, state } = useLocation();

  useEffect(() => {
    dispatch(menuChanged(state?.menu ?? 'login'));
  }, [menu]);

  return (
    <div
      className={cx('cloud--login', { st_signup: pathname.includes('signup') })}
    >
      <div className={cx('container', 'st_login')}>
        <div className={cx('inner')}>
          <h1 className={cx('blind')}>{LOGIN}</h1>

          <Logo wrapperClasses={['logo_area', 'login']} src={logo}>
            {pathname === '/login' ? (
              <p className={cx('desc')}>
                <span>{SERVICE_DESC}</span>
              </p>
            ) : null}
          </Logo>

          <div className={cx('form_area')}>
            <Outlet></Outlet>
          </div>
        </div>
      </div>
    </div>
  );
}
